<!-- eslint-disable vue/no-multiple-template-root -->
<script>
export default {
  name: 'titleContainer',
  props: {
    rank: {
      type: Number,
      default: 0,
      isRequired: true,
    },
    title: {
      type: String,
      default: '',
      isRequired: true,
    },
    textColor: {
      type: String,
      default: '',
      isRequired: true,
    },
    color: {
      type: String,
      default: '',
      isRequired: true,
    },
    alternativeColor: {
      type: String,
      default: '',
      isRequired: false,
    },
    simpleColor: {
      type: Boolean,
      default: false,
    },
    haveTooltip: {
      type: Boolean,
      default: false,
    },
    fontText: {
      type: String,
      default: '12px',
      isRequired: false,
    },
    heightChip: {
      type: String,
      default: null,
      isRequired: false,
    },
    disabledToolTip: {
      type: Boolean,
      default: false,
      isRequired: false,
    },
  },
  computed: {
    txtColor: function () {
      return this.simpleColor && this.rank === 3
        ? 'white'
        : this.simpleColor && this.rank !== 3
          ? '#212121'
          : this.textColor;
    },
  },
};
</script>
<template>
  <v-tooltip :value="haveTooltip" top :disabled="disabledToolTip">
    <template v-slot:activator="{ on }">
      <v-chip :color="simpleColor && alternativeColor
          ? alternativeColor
          : simpleColor && !alternativeColor
            ? textColor
            : color
        " :text-color="txtColor" class="title-chip" v-on="on"
        style="font-size: 11px !important; height: 24px !important"
        :style="heightChip && { height: heightChip + '!important' }">
        <div class="line-clamp-1" :style="{ fontSize: fontText }">
          {{ title }}
        </div>
      </v-chip>
    </template>
    <span :style="{ fontSize: fontText }">{{ title }}</span>
  </v-tooltip>
</template>
<style scoped lang="scss">
.overflow-x-auto {
  overflow-x: auto;
}

.title-chip {
  font-weight: 500;
}
</style>
